var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('base-breadcrumbs',{staticClass:"mb-12",attrs:{"items":_vm.breadcrumbs}}),_c('div',{staticStyle:{"font-weight":"600"},style:({
			fontSize: _vm.$vuetify.breakpoint.smAndDown ? '1.5rem' : '2rem',
		})},[_vm._v(" "+_vm._s(_vm._get(_vm.team, 'company.name') || 'Company')+" ")]),_c('company-metrics-btns',{staticClass:"mt-10",attrs:{"teams-summary":_vm.teamsSummary,"loading-teams-summary":_vm.loadingTeamsSummary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }